import React, { useContext, useState } from "react";
import ListItems from "../../components/ListItems";
import PrimaryBtn from "../../components/PrimaryBtn";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import InputForm from "../../components/InputForm";
import { useSelector } from "react-redux";
import { sidebarRoutes } from "../../constants/appConstants.js";
import { AuthContext } from "../../context/AuthContext/index.js";
import { NavigationMenu } from "../../constants/navigationConfig.js";

const Home = () => {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const { user } = useContext(AuthContext);
  const { currentMenu } = useSelector((state) => state.menu);
  const items = useSelector((state) => state.admin.users);

  const visibleMenuItems = NavigationMenu.filter(
    (item) => item.name && (item.alwaysVisible || user?.page_view?.includes(item.id))
  );

  return (
    <div className="max-w-5xl">
      <h2 className="font-semibold mb-2 text-xl md:text-2xl text-gray-800">Medical AI Suite</h2>
      <p className="text-gray-500 mb-6 text-sm">Select a module to get started</p>
      
      {currentMenu === sidebarRoutes.USERS ? (
        <>
          <Popup
            onClose={closeModal}
            modal
            open={open}
            closeOnDocumentClick
            position="center center"
          >
            <InputForm handleClose={closeModal} />
          </Popup>
          <div className="flex justify-end mb-4">
            <PrimaryBtn
              onClick={() => setOpen((o) => !o)}
              text={"+ Add User"}
            />
          </div>
          <ListItems items={items} />
        </>
      ) : (
        <div className="grid gap-3 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {visibleMenuItems.map((navItem) => {
            const IconComponent = navItem.icon;
            return (
              <div
                key={navItem.id}
                onClick={() => (window.location.href = navItem.route)}
                className="flex items-start gap-3 p-4 bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:shadow-md cursor-pointer transition-all duration-200 group"
              >
                <div 
                  className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${navItem.color}15` }}
                >
                  <IconComponent 
                    size={20} 
                    color={navItem.color}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-gray-900 text-sm group-hover:text-gray-700 leading-tight">
                    {navItem.name}
                  </h3>
                  <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                    {navItem.description}
                  </p>
                </div>
                <svg 
                  className="w-4 h-4 text-gray-400 group-hover:text-gray-600 flex-shrink-0 mt-0.5" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Home;
